// extracted by mini-css-extract-plugin
module.exports = {"facet":"Facet_facet___7LO0","count":"Facet_count__GSi4h"};